// Puerto verbatim de packages/hce/src/hce/forms/vitalSigns.ts — sin
// dependencias de UI, un Observation por signo, perfil vital-signs estándar
// de FHIR, código LOINC.
export const VITAL_SIGNS_CATEGORY = {
  coding: [{ system: 'http://terminology.hl7.org/CodeSystem/observation-category', code: 'vital-signs', display: 'Vital Signs' }],
};

export interface DefinicionSignoVital {
  clave: string;
  etiqueta: string;
  loinc: string;
  unidad: string;
  unidadUcum: string;
}

export const SIGNOS_VITALES: DefinicionSignoVital[] = [
  { clave: 'temperatura', etiqueta: 'Temperatura', loinc: '8310-5', unidad: '°C', unidadUcum: 'Cel' },
  { clave: 'fc', etiqueta: 'Frecuencia cardíaca', loinc: '8867-4', unidad: 'lpm', unidadUcum: '/min' },
  { clave: 'fr', etiqueta: 'Frecuencia respiratoria', loinc: '9279-1', unidad: 'rpm', unidadUcum: '/min' },
  { clave: 'sato2', etiqueta: 'Saturación de oxígeno', loinc: '59408-5', unidad: '%', unidadUcum: '%' },
  { clave: 'peso', etiqueta: 'Peso', loinc: '29463-7', unidad: 'kg', unidadUcum: 'kg' },
  { clave: 'talla', etiqueta: 'Talla', loinc: '8302-2', unidad: 'cm', unidadUcum: 'cm' },
];

/** Busca un signo vital del catálogo por clave — lanza si no existe (catálogo estático, un typo es un bug de programación, no un dato faltante). Reusado por 113/114 (Fase 4). */
export function signoVitalPorClave(clave: string): DefinicionSignoVital {
  const signo = SIGNOS_VITALES.find((s) => s.clave === clave);
  if (!signo) throw new Error(`Signo vital "${clave}" no encontrado en el catálogo`);
  return signo;
}

// Presión arterial va aparte: un solo Observation con dos component (perfil
// vital-signs estándar de FHIR para PA), no dos Observation sueltos.
export const PA_SISTOLICA_LOINC = '8480-6';
export const PA_DIASTOLICA_LOINC = '8462-4';
export const PA_PANEL_LOINC = '85354-9';
